define('home/mixins/withTruncate',[
    'jquery',
    'underscore',
], function (
    $,
    _
) {
    'use strict';

    var withTruncate = {
        onDomRefresh: function (_onDomRefresh) {
            if (_onDomRefresh)
                _onDomRefresh.call(this);

            this.$('.truncate').each(function (__, el) {
                $(el).trunk8({
                    lines: $(el).data('truncateLines') || 1,
                });
            });

            this.trigger('truncate:complete');
        },
    };

    return function () {
        this.onDomRefresh = _.wrap(this.onDomRefresh, withTruncate.onDomRefresh);
    };
});

